import { useIsShellHosted, useShellChrome } from 'lib/context/ShellContext/ShellContext';

import Button from 'components/shared/Button/Button';

// Renders nothing outside the shell's page content, so a modal's own table never picks up the
// page's actions.
const ChromeActions = () => {
  const isHosted = useIsShellHosted();
  const { primaryAction, headerActions } = useShellChrome() || {};

  if (!isHosted || (!primaryAction && !headerActions)) return null;

  return (
    <>
      {headerActions}
      {primaryAction && (
        <Button
          text={primaryAction.label}
          icon={primaryAction.icon || 'add-square-mono'}
          size="xs"
          onClick={primaryAction.onClick}
          isDisabled={primaryAction.disabled}
          tooltip={primaryAction.tooltip}
          data-qa="page-primary-action"
        />
      )}
    </>
  );
};

export default ChromeActions;
